import React, { FC, useContext } from "react";
import { GridLegacy as Grid } from "@mui/material";

import { IPreferences } from "../../logic/api";

import EditableField, {
  EditableFieldTypes,
} from "../../components/editable/EditableField/EditableField";
import EditableGroup, {
  EditableGroupType,
} from "../../components/editable/EditableGroup/EditableGroup";
import NotchedCard from "../../components/cards/NotchedCard/NotchedCard";

import { SessionContext } from "../../utility/useSession";
import styles from "./styles";
import { useTranslation } from "react-i18next";

interface IBusWalkAroundSettingsProps {
  onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const BusWalkAroundSettings: FC<IBusWalkAroundSettingsProps> = ({ onSave }) => {
  const session = useContext(SessionContext);

  if (!session.current.site) {
    return null;
  }

  const { t } = useTranslation();


  return (
    <Grid item xs={12}>
      <NotchedCard label={t("menuItems.busWalkarounds")} style={styles.card}>
        <EditableGroup<IPreferences>
          id="busWalkAroundSettings"
          editType={EditableGroupType.switchableEditing}
          data={session.current.site.preferences}
          onDataChanged={(data) => onSave({
            bus_walkaround_enabled: data.bus_walkaround_enabled,
          })}
          testId="bus-walkaround-settings"
        >
          <Grid container>
            <Grid item sm={2} xs={6}>
              <EditableField<IPreferences, boolean>
                useFullWidthWhenEditing={false}
                inputType={EditableFieldTypes.switch}
                label={t("reports.enabled")}
                onProvide={(data) =>
                  Boolean(data.bus_walkaround_enabled)
                }
                onChange={(data, value) =>
                  data.bus_walkaround_enabled = Boolean(value)
                }
                testId="settings-bus-walkaround-enabled-switch"
              />
            </Grid>
          </Grid>
        </EditableGroup>
      </NotchedCard>
    </Grid>
  );
};
